export enum OrderType {
  RESERVED1,
  LIMIT_TP,
  LIMIT_SL,
  LIMIT_CALL,
  ALGO,
  RESERVED3,
  BENCHMARK,
  BMALGO,
  MARKET,
  MARKET_IOC,
  MARKET_FOK,
}

export namespace OrderType {
  let elements = [
    OrderType.RESERVED1,
    OrderType.LIMIT_TP,
    OrderType.LIMIT_SL,
    OrderType.LIMIT_CALL,
    OrderType.ALGO,
    OrderType.RESERVED3,
    OrderType.BENCHMARK,
    OrderType.BMALGO,
    OrderType.MARKET,
    OrderType.MARKET_IOC,
    OrderType.MARKET_FOK,
  ];
  let alias = "com.bcdfx.model.OrderType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
